export default __webpack_public_path__ + "static/media/oneil.2e5e59ed.png";